import { render, staticRenderFns } from "./GlobalSportsHeaderCard.vue?vue&type=template&id=aa158590&scoped=true"
import script from "./GlobalSportsHeaderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSportsHeaderCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSportsHeaderCard.vue?vue&type=style&index=0&id=aa158590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa158590",
  null
  
)

export default component.exports